import ApiService from "api/ApiService";

interface NewFileUploadRequestResponse {
  success: boolean;
  message?: string;
  signed_url?: string;
  blob_name?: string;
}

export enum FilePurpose {
  Model,
  SampleData,
}

export default class StorageService {
  private static getStorageURL(): string {
    return "api/store";
  }

  public static async newFileUploadRequest(
    project_id: string,
    file_name: string,
    purpose: FilePurpose,
  ): Promise<NewFileUploadRequestResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getStorageURL()}/signed_url`,
          method: "POST",
          data: {
            project_id,
            file_name,
            purpose,
          },
        },
        true,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async uploadFile(
    url: string,
    file: File,
  ): Promise<NewFileUploadRequestResponse> {
    try {
      const response = await ApiService.request(
        {
          url,
          method: "PUT",
          data: file,
          headers: {
            "Content-Type": file.type,
          },
        },
        true,
        "application/octet-stream",
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async sendFileUploadSuccess(
    project_id: string,
    blob_name: string,
    file_url: string,
    file_name: string,
    file_size: number,
    purpose: FilePurpose,
  ): Promise<NewFileUploadRequestResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getStorageURL()}/upload_success`,
          method: "POST",
          data: {
            project_id,
            blob_name,
            file_url,
            file_name,
            file_size,
            purpose,
          },
        },
        true,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
